import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneheritagetourcab() {



  const cardData = {
"keyword": "Pune Heritage Tour Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Heritage Tour Cab for travelers who want to explore the rich history, culture, and architectural legacy of Pune in a convenient and well-planned way. Whether you are a history lover, student group, family traveler, or tourist visiting Pune for the first time, our cab service ensures a smooth and informative sightseeing experience. With experienced drivers who understand Pune’s historical routes and landmarks, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience across heritage sites. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible half-day and full-day packages, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and enriching journey through Pune’s most iconic heritage destinations.",

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is one of Pune’s most iconic historical landmarks built by the Peshwas in 1732. Known for its grand architecture, historic gates, and stories of Maratha rule, it remains a central attraction in any heritage tour of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace is a significant heritage monument associated with India’s freedom struggle. It served as a prison for Mahatma Gandhi and Kasturba Gandhi and now houses a museum showcasing historical artifacts and memorabilia."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description":
      "Raja Dinkar Kelkar Museum is a cultural treasure showcasing thousands of artifacts including sculptures, musical instruments, paintings, and traditional Indian household items, reflecting India’s rich heritage."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description":
      "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved out of a single rock in the 8th century. It is a remarkable example of early Indian architecture in the heart of Pune city."
  },
  {
    "title": "Lal Mahal",
    "description":
      "Lal Mahal is a historic monument associated with Chhatrapati Shivaji Maharaj’s childhood. It showcases important events from Maratha history and is located near Shaniwar Wada."
  },
  {
    "title": "Vishrambaug Wada",
    "description":
      "Vishrambaug Wada is a beautifully designed wooden mansion built by the Peshwas, known for its intricate architecture and historical significance in Pune’s royal past."
  },
  {
    "title": "Parvati Hill Temple",
    "description":
      "Parvati Hill Temple is a historic hilltop complex featuring ancient temples and panoramic views of Pune city. It is a peaceful blend of spirituality, history, and scenic beauty."
  },
  {
    "title": "Shinde Chhatri",
    "description":
      "Shinde Chhatri is a memorial dedicated to Mahadji Shinde, featuring beautiful Anglo-Rajasthani architecture and intricate carvings, making it an important heritage site in Pune."
  },
  {
    "title": "Sarasbaug Ganpati Temple",
    "description":
      "Sarasbaug Ganpati Temple is a famous spiritual and historical site located in a scenic garden. It is a peaceful stop combining devotion and heritage significance."
  },
  {
    "title": "Pune Heritage City Route",
    "description":
      "The Pune Heritage Tour route covers ancient forts, royal palaces, museums, temples, and colonial-era buildings, offering a complete journey through the city’s rich Maratha and cultural history."
  }
],



services: [
  {
    name: "Pune Heritage Tour Cab",
    description: "Pune heritage tour cab service provides reliable transportation for travelers exploring the historical landmarks and cultural attractions of Pune. Comfortable vehicles with experienced drivers ensure smooth city travel for families, tourists, and history enthusiasts. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different sightseeing requirements. Flexible booking options allow convenient heritage tour cab reservations."
  },
  {
    name: "Pune Historical Tour Taxi",
    description: "Pune historical tour taxi service offers dependable transportation for sightseeing tours to famous historical places and monuments across Pune with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth local travel suitable for heritage tourism, museum visits, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient historical tour taxi reservations."
  },
  {
    name: "Pune Heritage Sightseeing Cab",
    description: "Pune heritage sightseeing cab service provides comfortable transportation for passengers visiting forts, museums, temples, old city attractions, and cultural landmarks in Pune. Vehicles ensure reliable local travel with experienced chauffeurs offering safe and smooth city journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day sightseeing and heritage tourism requirements. Flexible booking options allow convenient heritage sightseeing cab reservations."
  },
  {
    name: "Pune Old City Tour Cab",
    description: "Pune old city tour cab service offers reliable transportation with comfortable vehicles and professional drivers for exploring Pune’s traditional markets, heritage streets, temples, and old city attractions. Vehicles provide smooth city travel suitable for tourism, shopping trips, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy old city tour cab reservations."
  },
  {
    name: "Pune Cultural Tour Taxi",
    description: "Pune cultural tour taxi service provides dependable transportation solutions for passengers traveling across Pune to experience cultural landmarks, festivals, museums, and heritage attractions. Vehicles are suitable for city travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for tourism, cultural visits, and local sightseeing tours. Flexible booking options allow convenient cultural tour taxi reservations."
  },
  {
    name: "Pune Heritage Travel Cab",
    description: "Pune heritage travel cab service provides transparent and reliable transportation for travelers visiting Pune’s famous heritage sites and historical attractions. Travelers can enjoy comfortable journeys with experienced drivers familiar with local sightseeing routes and heritage destinations. Comfortable vehicles ensure smooth city travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient heritage travel cab reservations."
  },
  {
    name: "Best Pune Heritage Cab Service",
    description: "Best Pune heritage cab service provides economical and comfortable transportation for travelers planning heritage sightseeing tours across Pune city. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, museum visits, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient heritage cab reservations."
  },
  {
    name: "Cheap Pune Heritage Taxi",
    description: "Cheap Pune heritage taxi service offers convenient transportation for passengers planning affordable heritage sightseeing trips across Pune city. Comfortable vehicles provide smooth local travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for local sightseeing, museum visits, and tourism tours. Flexible booking options allow economical heritage taxi reservations."
  },
  {
    name: "SUV Pune Heritage Tour Cab",
    description: "SUV Pune heritage tour cab service provides spacious transportation for families and groups traveling across Pune for heritage sightseeing and tourism. SUV vehicles offer comfortable seating, luggage capacity, and smooth city performance suitable for family outings and cultural tours. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV heritage cab reservations."
  },
  {
    name: "Innova Pune Heritage Cab",
    description: "Innova Pune heritage cab service provides premium SUV transportation for passengers seeking comfortable and reliable city sightseeing travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, heritage sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova heritage cab reservations."
  },
  {
    name: "Sedan Pune Heritage Taxi",
    description: "Sedan Pune heritage taxi service offers economical and comfortable transportation for solo travelers, couples, and small families exploring Pune’s historical and cultural attractions. Sedan vehicles provide smooth city travel with comfortable seating and luggage space suitable for heritage sightseeing journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan heritage taxi reservations."
  },
  {
    name: "Pune Cultural Sightseeing Cab",
    description: "Pune cultural sightseeing cab service offers dependable transportation for passengers exploring Pune’s cultural centers, museums, temples, heritage landmarks, and traditional attractions. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient cultural sightseeing cab reservations."
  },
  {
    name: "Pune History Tour Cab",
    description: "Pune history tour cab service provides reliable transportation for travelers planning educational and historical sightseeing tours across Pune. Comfortable vehicles ensure smooth and safe city travel suitable for tourists, students, families, and history enthusiasts. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient history tour cab reservations."
  },
  {
    name: "Pune Museum Tour Taxi",
    description: "Pune museum tour taxi service offers comfortable transportation for passengers visiting museums, galleries, and cultural institutions across Pune city. Vehicles ensure reliable local travel with experienced chauffeurs offering safe and smooth city journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for educational trips, cultural tourism, and sightseeing requirements. Flexible booking options allow convenient museum tour taxi reservations."
  },
  {
    name: "Pune Heritage Travel Package Cab",
    description: "Pune heritage travel package cab service provides complete transportation solutions for travelers planning heritage tours and cultural sightseeing packages across Pune. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, shopping trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient heritage travel package cab reservations."
  }
],

tableData: [
  ["Pune Heritage Tour Cab", "Pune Historical Tour Taxi"],
  ["Pune Heritage Sightseeing Cab", "Pune Old City Tour Cab"],
  ["Pune Cultural Tour Taxi", "Pune Heritage Travel Cab"],
  ["Best Pune Heritage Cab Service", "Cheap Pune Heritage Taxi"],
  ["SUV Pune Heritage Tour Cab", "Innova Pune Heritage Cab"],
  ["Sedan Pune Heritage Taxi", "Pune Cultural Sightseeing Cab"],
  ["Pune History Tour Cab", "Pune Museum Tour Taxi"],
  ["Pune Heritage Travel Package Cab", "Pune Heritage Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Heritage Tour Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Heritage Tour cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and informative sightseeing travel."
      },
      {
        WhyChooseheading: "Affordable Heritage Tour Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Heritage Tour cab pricing with transparent fare details and no hidden charges. Customers receive complete tour package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Heritage Tour Cab Availability",
        WhyChoosedescription: "Our Pune Heritage Tour cab service operates 24 hours a day for historical sightseeing, cultural tours, family outings, tourist visits, and customized heritage travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during Pune heritage tours."
      },
      {
        WhyChooseheading: "Customized Heritage Sightseeing Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Shaniwar Wada tours, Aga Khan Palace visits, Lal Mahal sightseeing, Pataleshwar Temple tours, and customized heritage travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, students, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Heritage Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune’s historical attractions and heritage routes, ensuring smooth travel and timely visits to important cultural landmarks."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Heritage Tour cab service?", answer: "Pune Heritage Tour cab service provides comfortable taxi transportation for visiting famous historical places, forts, palaces, and cultural attractions in Pune." },
    { question: "Is Pune Heritage Tour cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Heritage Tour cab service." },
    { question: "Which vehicles are available for heritage tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized heritage tour packages?", answer: "Yes, customers can book customized heritage sightseeing packages according to their travel requirements." },
    { question: "Which heritage places are covered in the Pune Heritage Tour?", answer: "Shivai Travels covers attractions like Shaniwar Wada, Aga Khan Palace, Lal Mahal, Vishrambaug Wada, Pataleshwar Temple, and other historical landmarks." },
    { question: "Are all heritage tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable sightseeing travel." },
    { question: "Can I book Pune Heritage Tour cab service online?", answer: "Yes, customers can easily book Pune Heritage Tour cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group sightseeing tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group sightseeing travel." },
    { question: "Are Pune Heritage Tour cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Heritage Tour cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Nikhil Deshpande",
      feedback:
        "Booked Pune Heritage Tour cab service with Shivai Travels. Comfortable vehicle, smooth sightseeing experience, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Poonam Patil",
      feedback:
        "Excellent Pune Heritage Tour taxi service. Affordable pricing, clean cab, and wonderful historical tour experience.",
      rating: 5
    }
  ];













  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Heritage Tour Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-heritage-tour-cab.jpg",
  "description": "Book Pune Heritage Tour cab service for comfortable sightseeing of historical and cultural places. Shivai Travels offers customized heritage travel packages with sedan, SUV, Innova, and luxury cab options available 24x7 for old city tours, museums, forts, and cultural attractions.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-heritage-tour-cab"
  }
};









  return (
    <div>
<Helmet>
  <title>Pune Heritage Tour Cab | Historical Sightseeing Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Heritage Tour cab service for historical and cultural sightseeing. Affordable packages with sedan, SUV, Innova, and luxury cabs available 24x7 for Pune old city tours, museums, forts, and heritage travel."
  />

  <meta
    name="keywords"
    content="pune heritage tour cab, pune historical tour taxi, pune heritage sightseeing cab, pune old city tour cab, pune cultural tour taxi, pune heritage travel cab, best pune heritage cab service, cheap pune heritage taxi, suv pune heritage tour cab, innova pune heritage cab, sedan pune heritage taxi, pune cultural sightseeing cab, pune history tour cab, pune museum tour taxi, pune heritage travel package cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneheritagetourcab;